import React, { Component } from 'react';

import classes from './Loader.css';
import ufcLogo from '../../assets/images/ufc-icon.png';
import Icon from '../UI/Icon/Icon';
import Spinner from '../UI/Spinner/Spinner';

class Loader extends Component {

  render() {

    let animate = null;
    if (this.props.animate) {
      animate = classes.Animate;
    }

    return (
      <div className={[classes.Loader, animate].join(' ')}>
        <div className={classes.ContentHolder}>
          <Icon iconClass={classes.UfcIcon} iconSource={ufcLogo} />
          <Spinner inline fontSize="10px" />
          { this.props.message ? <p className={classes.Message}><em>{this.props.message}</em></p> : null }
        </div>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js